export default __webpack_public_path__ + "static/media/case-study-10-light-unmanned-aircraft.52a258cf.mp4";